import type { InvoiceRecipientOption } from '@tandemone/types'
import { createContext } from 'react'

export type PaymentTerm =
  | 'due_on_receipt'
  | 'net_15'
  | 'net_30'
  | 'net_45'
  | 'net_60'
  | 'custom'

export const PAYMENT_TERMS: {
  value: PaymentTerm
  label: string
  days: number
}[] = [
  { value: 'due_on_receipt', label: 'Due on receipt', days: 0 },
  { value: 'net_15', label: 'Net 15', days: 15 },
  { value: 'net_30', label: 'Net 30', days: 30 },
  { value: 'net_45', label: 'Net 45', days: 45 },
  { value: 'net_60', label: 'Net 60', days: 60 }
]

export type LineItemDraft = {
  key: string
  description: string
  quantity: string
  unitPrice: string
}

export type InvoiceFormState = {
  recipient: InvoiceRecipientOption | null
  purchaseOrderNumber: string
  dueAt: string
  paymentTerm: PaymentTerm
  currency: string
  notes: string
  taxAmount: string
  shippingAmount: string
  lineItems: LineItemDraft[]
  submitting: boolean
  error: string
}

export type StringField =
  | 'purchaseOrderNumber'
  | 'currency'
  | 'notes'
  | 'taxAmount'
  | 'shippingAmount'

export type InvoiceFormAction =
  | { type: 'SET_RECIPIENT'; payload: InvoiceRecipientOption | null }
  | { type: 'SET_FIELD'; field: StringField; value: string }
  | { type: 'SET_DUE_DATE'; value: string }
  | { type: 'SET_TERM'; value: PaymentTerm }
  | { type: 'ADD_LINE_ITEM' }
  | { type: 'UPDATE_LINE_ITEM'; key: string; patch: Partial<LineItemDraft> }
  | { type: 'REMOVE_LINE_ITEM'; key: string }
  | { type: 'SUBMIT_START' }
  | { type: 'SET_ERROR'; message: string }

export type InvoiceFormDerived = {
  subtotal: number
  taxAmount: number
  shippingAmount: number
  total: number
  isValid: boolean
}

export type InvoiceFormContextValue = {
  state: InvoiceFormState
  derived: InvoiceFormDerived
  dispatch: React.Dispatch<InvoiceFormAction>
  submit: (action: 'draft' | 'send') => void
}

export const InvoiceFormContext = createContext<InvoiceFormContextValue | null>(
  null
)
